var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 3H20C20.5523 3 21 3.44772 21 4V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V4C3 3.44772 3.44772 3 4 3H6C6 4.10457 6.89543 5 8 5C9.10457 5 10 4.10457 10 3H14C14 4.10457 14.8954 5 16 5C17.1046 5 18 4.10457 18 3ZM5 20H19V8H5V20ZM8 16H12C12.5523 16 13 16.4477 13 17C13 17.5523 12.5523 18 12 18H8C7.44772 18 7 17.5523 7 17C7 16.4477 7.44772 16 8 16ZM8 13H16C16.5523 13 17 13.4477 17 14C17 14.5523 16.5523 15 16 15H8C7.44772 15 7 14.5523 7 14C7 13.4477 7.44772 13 8 13ZM10 10H16C16.5523 10 17 10.4477 17 11C17 11.5523 16.5523 12 16 12H10C9.44772 12 9 11.5523 9 11C9 10.4477 9.44772 10 10 10ZM8 1C8.55228 1 9 1.44772 9 2V3C9 3.55228 8.55228 4 8 4C7.44772 4 7 3.55228 7 3V2C7 1.44772 7.44772 1 8 1ZM16 1C16.5523 1 17 1.44772 17 2V3C17 3.55228 16.5523 4 16 4C15.4477 4 15 3.55228 15 3V2C15 1.44772 15.4477 1 16 1Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_53_4060",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 1,
    width: 18,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 3H20C20.5523 3 21 3.44772 21 4V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V4C3 3.44772 3.44772 3 4 3H6C6 4.10457 6.89543 5 8 5C9.10457 5 10 4.10457 10 3H14C14 4.10457 14.8954 5 16 5C17.1046 5 18 4.10457 18 3ZM5 20H19V8H5V20ZM8 16H12C12.5523 16 13 16.4477 13 17C13 17.5523 12.5523 18 12 18H8C7.44772 18 7 17.5523 7 17C7 16.4477 7.44772 16 8 16ZM8 13H16C16.5523 13 17 13.4477 17 14C17 14.5523 16.5523 15 16 15H8C7.44772 15 7 14.5523 7 14C7 13.4477 7.44772 13 8 13ZM10 10H16C16.5523 10 17 10.4477 17 11C17 11.5523 16.5523 12 16 12H10C9.44772 12 9 11.5523 9 11C9 10.4477 9.44772 10 10 10ZM8 1C8.55228 1 9 1.44772 9 2V3C9 3.55228 8.55228 4 8 4C7.44772 4 7 3.55228 7 3V2C7 1.44772 7.44772 1 8 1ZM16 1C16.5523 1 17 1.44772 17 2V3C17 3.55228 16.5523 4 16 4C15.4477 4 15 3.55228 15 3V2C15 1.44772 15.4477 1 16 1Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_53_4060)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarAlt);
export default __webpack_public_path__ + "static/media/calendar-alt.0dc2ff1c24088f701139c82f7d96888b.svg";
export { ForwardRef as ReactComponent };